import { useContext } from 'react';
import { ABTestContext } from './ab-test.context';
export const useABTestContext = () => {
    return useContext(ABTestContext);
};
